<div class="cartPoses">
  <div class="cartPoses_selectors" *ngIf="showPosSelectors">
    <div class="cartPoses_select cartPoses_cities" *ngIf="site === 'visionexpress'">
      <ng-select (change)="selectCity(site, $event)" [items]="cities" [placeholder]="'cart.poses.select.city.placeholder' | translate" [notFoundText]="'ng-select.notFoundText' | translate" class="cartPoses_select_box"></ng-select>
      <p class="cartPoses_error" *ngIf="error === 'city'" scroll-to="cartDeliveryPayment_delivery">
        {{"cart.poses.city.error.text" | translate}}
      </p>
    </div>
    <div class="cartPoses_select cartPoses_poses" *ngIf="showPoses">
      <ng-select (change)="selectPos($event)" [items]="poses" [placeholder]="'cart.poses.select.pos.placeholder' | translate" [notFoundText]="'ng-select.notFoundText' | translate" class="cartPoses_select_box"></ng-select>
      <p class="cartPoses_error" *ngIf="error === 'pos'" scroll-to="cartDeliveryPayment_delivery">
        {{"cart.poses.pos.error.text" | translate}}
      </p>
    </div>
    <div class="cartPoses_info" *ngIf="showPosInfo">
      <div class="cartPoses_cell">
        <b class="cartPoses_cell_header">{{selectedPos?.displayName}}</b>
        <address class="cartPoses_cell_content">
          {{selectedPos?.address?.street}}
          <br>{{selectedPos?.address?.postalCode}} {{selectedPos?.address?.town}}
        </address>
      </div>
      <div  class="cartPoses_cell">
        <b class="cartPoses_cell_header">{{'cart.poses.openhours.text' | translate}}</b>
        <ul class="cartPoses_cell_content">
          <li *ngFor="let day of selectedPos.openingHours">{{day}}</li>
        </ul>
      </div>
      <button (click)="selectDelivery(selectedPos.name)" type="button" class="cartPoses_button">{{'cart.poses.choose.button.text' | translate}}</button>
      <p class="cartPoses_error" *ngIf="error === 'confirm'" scroll-to="cartDeliveryPayment_delivery">
        {{"cart.poses.confirm.error.text" | translate}}
      </p>
    </div>
  </div>
  <div class="cartPoses_selected" *ngIf="showSelectedPos">
    <address class="cartPoses_selected_address">
      {{selectedPos?.displayName}}
      <br>{{selectedPos?.address?.street}}
      <br>{{selectedPos?.address?.postalCode}} {{selectedPos?.address?.town}}
    </address>
    <button (click)="newPos()" *ngIf="asmMode !== 'true' || mode === 'subscriptions'" type="button" class="cartPoses_selected_button">{{'cart.poses.change.button.text' | translate}}</button>
  </div>
</div>
